import React from 'react'

import styled from 'styled-components'


const Wrapper = styled.div`
  text-align: center;
  font-size: 14px;
`



const Text = (props) => (
  <Wrapper style={props.style}>{props.children}</Wrapper>
)


export default Text